import { withRedirectToLogin } from '../../hocs/withRedirectToLogin';
import { Layout } from 'antd';
import { FC, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MeProfile } from '../../shared/MySrcm';
import { UserRole } from '../../shared/VolunteerApplicationServiceTypes';
import { useBatchId } from '../../hooks/useBatchId';
import { APPLICANT_HOME, ROOT, SELECT_MODULE } from '../../shared/Routes';
import { useAuth } from '../../hooks/useAuth';
import { AppHeader } from './AppHeader';

const { Content } = Layout;

interface LayoutProps {
	logout?: () => Promise<void>;
	firebaseId?: string | null;
	srcmId?: string;
	mySrcmProfile?: MeProfile | null;
	loading?: boolean;
	selectedRole?: UserRole | null;
}

export const FunctionaryLayout: FC<LayoutProps> = ({
	logout,
	firebaseId,
	mySrcmProfile,
	srcmId,
	loading,
	selectedRole,
}: LayoutProps) => {
	const { navigateToRoute } = useBatchId();
	const { pathname } = useLocation();
	const { isLoggedIn } = useAuth();

	useEffect(() => {
		if (!pathname.includes('hfnauth') && !(isLoggedIn && isLoggedIn())) {
			navigateToRoute(ROOT);
		}
	}, [isLoggedIn, navigateToRoute, pathname]);

	if (selectedRole && [UserRole.APPLICANT].includes(selectedRole)) {
		navigateToRoute(APPLICANT_HOME);
	}

	const isHeaderHidden = pathname === SELECT_MODULE;

	return (
		<>
			{isHeaderHidden ? (
				<Layout className="mainlayout rounded-md bg-white">
					<Content className="bg-white">
						{!loading && (
							<Outlet context={{ srcmId, firebaseId, selectedRole }} />
						)}
					</Content>
				</Layout>
			) : (
				<>
					<AppHeader logout={logout} mySrcmProfile={mySrcmProfile} />
					<div className="flex justify-center bg-neutral-50 bg-bground-blue">
						<Layout className="mainlayout rounded-md p-[8px] bg-bground-blue w-full max-w-screen">
							<Content>
								{!loading && (
									<Outlet context={{ srcmId, firebaseId, selectedRole }} />
								)}
							</Content>
						</Layout>
					</div>
				</>
			)}
		</>
	);
};

export default withRedirectToLogin<object>(FunctionaryLayout);
